module.exports = __webpack_public_path__ + "static/media/puzze-piece.fd059805.png";